import React, { useEffect, useState } from 'react'
import { connect, useDispatch, useSelector } from 'react-redux'
import { ordemServicoOrcamentoAction } from '../../_actions'
import { styled } from '@mui/material/styles';
import DeleteIcon from '@mui/icons-material/Delete'
import PropTypes from 'prop-types'
import { useConfirm } from 'material-ui-confirm'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import moment from 'moment'
import {
  Grid,
  IconButton,
  Input,
  Paper,
  Tooltip,
  Skeleton,
  TablePagination,
  Table,
  TableContainer,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@mui/material'
import VisibilityIcon from '@mui/icons-material/Visibility';
import { withStyles } from '@mui/styles'
import { withRouter } from 'react-router-dom'
import { history, MANUAIS_CATEGORIAS } from '../../utils'
import TitleContent from '../TitleContent'
import { AccessControl } from '../../components/Utils/AccessControl'
import AccessDenied from '../Errors/AccessDenied'
import { Page } from 'components'
import { useDebounce } from 'use-debounce';
import { OrdemServicoMotivoExclusaoModal } from './ordemServicoMotivoExclusaoModal.component';

const styles = (theme) => ({
  root: {
    padding: theme.spacing(6, 6, 6, 6)
  },
  textField: {
    fontSize: '13px !important'
  }
})

const DivFormatted = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: 3
}));

const AlignedIcon = styled(InfoOutlinedIcon)(() => ({
  fontSize: '1.5em',
}));

const StatusText = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  height: '100%',
}));


const OrdemServicoOrcamento = (props) => {

  const confirm = useConfirm()
  const dispatch = useDispatch()
  const { classes } = props
  const { ordemServicoOrcamento } = props.ordemServicoOrcamento
  const { totalRegistros } = props.ordemServicoOrcamento
  const { isLoading } = props.ordemServicoOrcamento

  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const [term, setTerm] = useState('');
  const [debounceTerm] = useDebounce(term, 1000);
  const [order] = useState('data');
  const [direction] = useState('desc');
  const [ready,] = React.useState(false);

  const [modalOrcamentoMotivoExclusao, setModalOrcamentoMotivoExclusao] = useState(false);
  const toggleModalOrcamentoMotivoExclusao = () => setModalOrcamentoMotivoExclusao(!modalOrcamentoMotivoExclusao);
  const [orcamento, setOrcamento] = useState(null);

  const { idOrgao } = useSelector(
    (state) => state.usuarioOrgao
  )

  useEffect(() => {

    const fetchData = (page, limit, term) => {

      let filterModel = {
        Page: page,
        Limit: limit,
        Term: term ? term : '',
        Order: order,
        Direction: direction,
        IdOrgao: idOrgao ? idOrgao : 0
      };

      dispatch(ordemServicoOrcamentoAction.getOrdemServicoOrcamento(filterModel, true));
    };

    fetchData(page, limit, debounceTerm, order, direction);

  }, [page, limit, debounceTerm, order, direction, idOrgao]);

  useEffect(() => {

  }, [totalRegistros, isLoading]);

  useEffect(() => {
  }, [ready, props.ordemServicoOrcamento.isLoading])

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeLimit = (event) => {
    setLimit(parseInt(event?.target?.value, 10));
    setPage(0);
  };

  const handleChange = event => {
    setTerm(event?.target?.value);
  };

  const handleDeleteOrcamento = (n) => {
    confirm({
      title: 'Você deseja realmente excluir este Orçamento?',
      description: 'Essa operação é irreversível',
      disabled: props.ordemServicoOrcamento.isLoading,
      confirmationText: props.ordemServicoOrcamento.isLoading ? 'Excluindo Orçamento...' : 'Sim, excluir!',
    }).then(() => {
      handleOpenModalMotivoExclusao(n, true)
    })
  }

  const handleOpenModalMotivoExclusao = (n) => {
    setOrcamento(n);
    toggleModalOrcamentoMotivoExclusao();
  }

  return (
    <Page className={classes.root} title="Orçamentos Enviados">
      <AccessControl
        rule={'ordensServicoOrcamentos.list'} //permissão necessária para acessar conteúdo
        yes={() => (
          <div>
            {undefined !== ordemServicoOrcamento && ordemServicoOrcamento.length > 0 ? (
              <TitleContent
                length={ordemServicoOrcamento.length}
                subTitle={'GERÊNCIA DE ORÇAMENTOS'}
                title={'Lista de Orçamentos Enviados'}
                href={'/ordemServicoOrcamento'}
                telaManual={MANUAIS_CATEGORIAS.LISTAGEM_ORDEM_ORCAMENTO_ENVIADO}
              />
            ) : (
              <TitleContent
                length={0}
                subTitle={'GERÊNCIA DE ORÇAMENTOS'}
                title={'Lista de Orçamentos Enviados'}
                href={'/ordemServicoOrcamento'}
                telaManual={MANUAIS_CATEGORIAS.LISTAGEM_ORDEM_ORCAMENTO_ENVIADO}
              />
            )}
            <Grid container spacing={3}>
              <Grid item xl={3} lg={3} md={3} xs={12}>
                <Input
                  id="term"
                  label="term"
                  placeholder="Filtro"
                  value={term}
                  fullWidth
                  onChange={handleChange('term')}
                />
              </Grid>
            </Grid>
            <br />
            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Código</TableCell>
                    <TableCell>Data</TableCell>
                    <TableCell>Prazo</TableCell>
                    <TableCell>Órgão</TableCell>
                    <TableCell>Ordem de Serviço</TableCell>
                    <TableCell>Status</TableCell>
                    <TableCell align="right">Valor</TableCell>
                    <TableCell align="center">Ações</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {undefined !== ordemServicoOrcamento && ordemServicoOrcamento.length
                    ? ordemServicoOrcamento.map((n) => {
                      return (
                        <TableRow hover key={n.id} >
                          <TableCell component="th" scope="row" className={classes.textField}>
                            {n.id ? n.id : ''}
                          </TableCell>
                          <TableCell component="th" scope="row" className={classes.textField}>
                            {n.data ? moment(n.data).format("DD/MM/YYYY") : ''}
                          </TableCell>
                          <TableCell component="th" scope="row" className={classes.textField}>
                            {n.declinio ? '-' :
                              n.prazo ? moment(n.prazo).format("DD/MM/YYYY") : ''}
                          </TableCell>
                          <TableCell component="th" scope="row" className={classes.textField}>
                            {n.ordemServico && n.ordemServico.orgao ? n.ordemServico.orgao.nome : ''}
                          </TableCell>
                          <TableCell component="th" scope="row" className={classes.textField}>
                            {n.ordemServico ? '#' + n.ordemServico.id + ' ' + n.ordemServico.titulo : ''}
                          </TableCell>
                          <TableCell component="th" scope="row" className={classes.textField}>
                            <DivFormatted>
                              {n.motivo &&
                                <Tooltip title={n.motivo}>
                                  <AlignedIcon style={{
                                    cursor: 'pointer',
                                    fontSize: '1.5em'
                                  }}
                                  />
                                </Tooltip>
                              }
                              {/* se o orçamento for declínio, ele não terá status */}
                              <StatusText>
                                {n.declinio ? '-' :
                                  n.statusOrcamento == '1'
                                    ? 'APROVADO'
                                    : n.statusOrcamento == '2'
                                      ? 'RECUSADO'
                                      : 'PENDENTE DE ANÁLISE'}
                              </StatusText>
                            </DivFormatted>
                          </TableCell>
                          <TableCell component="th" scope="row" align="right" className={classes.textField}>
                            {/* se o orçamento for declínio, ele não terá valor para exibir */}
                            {n.declinio ? '-' :
                              Intl.NumberFormat('pt-BR', {
                                style: 'currency',
                                currency: 'BRL'
                              }).format(n.valor)
                            }
                          </TableCell>
                          <TableCell component="th" scope="row">
                            <AccessControl
                              rule={'ordensServicoOrcamentos.list'} //permissão necessária para acessar conteúdo
                              yes={() => (
                                <IconButton
                                  aria-label="Visualizar"
                                  component="span"
                                  onClick={() =>
                                    history.push(`/ordensServicoOrcamento/${n.id}`, n.ordemServico.id)
                                  }
                                  size="small"
                                >
                                  <Tooltip title={'Visualizar Orçamento'}>
                                    <Tooltip >
                                      <VisibilityIcon />
                                    </Tooltip>
                                  </Tooltip>
                                </IconButton>
                              )}
                            />
                            <AccessControl
                              rule={'ordensServicoOrcamentos.delete'} //permissão necessária para acessar conteúdo
                              yes={() => (
                                <IconButton
                                  aria-label="Excluir"
                                  component="span"
                                  onClick={() => handleDeleteOrcamento(n)}
                                  size="small"
                                >
                                  <Tooltip title={'Excluir Orçamento'}>
                                    <Tooltip >
                                      <DeleteIcon />
                                    </Tooltip>
                                  </Tooltip>
                                </IconButton>
                              )}
                            />
                          </TableCell>
                        </TableRow >
                      )
                    })
                    :
                    (
                      !isLoading ?
                        <TableRow>
                          <TableCell rowSpan={3} colSpan={8} align="center">Nenhum registro encontrado</TableCell>
                        </TableRow>
                        :
                        Array.apply(null, { length: 5 }).map((e, i) => (
                          <TableRow hover key={i}>
                            <TableCell component="th" scope="row">
                              <Skeleton animation="wave" />
                            </TableCell>
                            <TableCell component="th" scope="row">
                              <Skeleton animation="wave" />
                            </TableCell>
                            <TableCell component="th" scope="row">
                              <Skeleton animation="wave" />
                            </TableCell>
                            <TableCell component="th" scope="row">
                              <Skeleton animation="wave" />
                            </TableCell>
                            <TableCell component="th" scope="row">
                              <Skeleton animation="wave" />
                            </TableCell>
                            <TableCell component="th" scope="row">
                              <Skeleton animation="wave" />
                            </TableCell>
                            <TableCell component="th" scope="row">
                              <Skeleton animation="wave" />
                            </TableCell>
                            <TableCell component="th" scope="row">
                              <Skeleton animation="wave" />
                            </TableCell>
                          </TableRow>
                        ))
                    )
                  }
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              component="div"
              count={totalRegistros}
              page={page}
              labelRowsPerPage="Linhas por página"
              labelDisplayedRows={({ from, to }) => `${from}-${to} de ${totalRegistros}`}
              onPageChange={handleChangePage}
              rowsPerPage={limit}
              onRowsPerPageChange={handleChangeLimit}
            />
          </div >
        )
        }
        no={() => <AccessDenied />}
      />
      {
        (modalOrcamentoMotivoExclusao ?
          <OrdemServicoMotivoExclusaoModal
            toggle={toggleModalOrcamentoMotivoExclusao}
            modal={modalOrcamentoMotivoExclusao}
            props={props}
            orcamento={orcamento}
          />
          :
          null
        )
      }
    </Page >
  )
}
OrdemServicoOrcamento.propTypes = {
  classes: PropTypes.object.isRequired
}
const mapStateToProps = (state) => {
  return state
}
const connectedOrdemServicoOrcamentoPage = withRouter(
  connect(mapStateToProps, null, null)(withStyles(styles)(OrdemServicoOrcamento))
)
export { connectedOrdemServicoOrcamentoPage as OrdemServicoOrcamento }
